import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';

import React, { Component } from 'react';

import TextField from 'material-ui/TextField';
import Paper from 'material-ui/Paper';
import { MenuItem } from 'material-ui/Menu';
import SelectableItem from '../../common/dropdown/SelectableItem';

import Console from '../../../lib/debug';

export default class CalendarSwitcher extends Component {
    state = {
        value: '',
        suggestions: []
    };

    cancel = () => {
        this.props.cancel && this.props.cancel();
    };

    renderInput = inputProps => {
        const { ref, ...other } = inputProps;

        return (
            <TextField
                fullWidth
                autoFocus={true}
                InputProps={{
                    inputRef: ref,
                    ...other
                }}
            />
        );
    };

    renderSuggestion = (suggestion, { query, isHighlighted }) => {
        let value = this.getSuggestionValue(suggestion);

        return (
            <SelectableItem
                image={suggestion.logo || suggestion.image_profile}
                text={value}
                query={query}
                selected={isHighlighted}
            />
        );
    };

    renderSuggestionsContainer = options => {
        const { containerProps, children } = options;

        return (
            <Paper {...containerProps} square>
                {children}
            </Paper>
        );
    };

    getSuggestionValue = suggestion => {
        return this.props.getSuggestionValue(suggestion);
    };

    getSuggestions = value => {
        const inputValue = value.trim().toLowerCase();
        let options = this.props.options;

        if (!value) return options;

        return options.filter(suggestion => {
            let value = this.getSuggestionValue(suggestion);
            let regex = new RegExp(`${inputValue}+`, 'gi');
            return regex.test(value);
        });
    };

    handleSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestions: this.getSuggestions(value)
        });
    };

    handleSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    handleChange = (event, { newValue }) => {
        this.setState({
            value: newValue
        });
    };

    onSuggestionSelected = (event, { suggestion }) => {
        this.cancel();
        this.props.onSuggestionSelected(
            suggestion.group_program || suggestion.id
        );
    };

    render() {
        Console.render('CalendarSwitcher');
        return (
            <Autosuggest
                renderInputComponent={this.renderInput}
                suggestions={this.state.suggestions}
                onSuggestionSelected={this.onSuggestionSelected}
                onSuggestionsFetchRequested={
                    this.handleSuggestionsFetchRequested
                }
                onSuggestionsClearRequested={
                    this.handleSuggestionsClearRequested
                }
                renderSuggestionsContainer={this.renderSuggestionsContainer}
                getSuggestionValue={this.getSuggestionValue}
                highlightFirstSuggestion={true}
                shouldRenderSuggestions={() => true}
                renderSuggestion={this.renderSuggestion}
                inputProps={{
                    placeholder: 'Search...',
                    value: this.state.value,
                    onChange: this.handleChange,
                    onBlur: this.cancel
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/view/calendar/components/CalendarSwitcher.jsx